import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import LayoutSection from "../../components/NavigationAndLayouts/LayoutSection";
import AdminClient from "../../AdminClient";
import utils from "../../utils";
import Report from "../../components/basic/Report";

function AgentTournamentDetails(props) {
  const company = utils.getSessionItem("Company");
  const session = JSON.parse(utils.getSessionItem("user")).session;
  const adminClient = new AdminClient();
  const { t } = props;
  let tournamentId = utils.getSessionItem("current-tournament");
  let urlName = props.location.pathname.split("/");
  if (urlName.length > 4) tournamentId = urlName[urlName.length - 1];

  const [tournament, setTournament] = useState({});
  const [position, setPosition] = useState(-1);
  const [amount, setAmount] = useState(-1);
  const tournamentAux = JSON.parse(
    utils.getSessionItem("current-agent-tournament")
  );
  utils.setSessionItem(
    "ReportFilter-" + "agent_tournament_ranking",
    JSON.stringify([
      { field: "tournament", filter: "", value: tournamentAux.tournament },
    ])
  );

  const goBack = () => {
    props.history.push("/agents/promotions/tournaments");
  };
  const dataHeader = {
    backLink: goBack,
    title: t("Tournament details") + " " + tournament.name,
    urlHelp: "",
    idDoc: props.idDoc,
  };

  useEffect(async function () {
    const tournamentAux = JSON.parse(
      utils.getSessionItem("current-agent-tournament")
    );

    utils.setSessionItem(
      "ReportFilter-" + "agent_tournament_ranking",
      JSON.stringify([
        { field: "tournament", filter: "", value: tournamentAux.tournament },
      ])
    );
    let response = await adminClient.getAgentTournamentRanking(
      session,
      company,
      tournamentAux.tournament
    );
    console.log(
      "position = " +
        response.data.position +
        " tournament = " +
        tournamentAux.tournament
    );
    setPosition(response.data.position);
    setAmount(response.data.amount);
    setTournament(tournamentAux);
  }, []);

  return (
    <LayoutSection {...props} dataHeader={dataHeader}>
      <div className="card ">
        <div className="card-header">
          <h2>{tournament.cms?.title}</h2>
        </div>
        <div className="card-body">
          <div class="agent-tournament-details">
            <div
              class="agent-tournament-body"
              dangerouslySetInnerHTML={{ __html: tournament.cms?.body }}
            ></div>
            <div class="agent-tournament-dates">
              {t("Period")} : {t("From")} {tournament.init_date} {t("To")}{" "}
              {tournament.end_date}
            </div>
            {position > 0 && (
              <div>
                <div class="agent-tournament-position">
                  {t("Your position is")} : {position}
                </div>
                <div class="agent-tournament-amount">
                  {t("Your points are")} : {amount}
                </div>
              </div>
            )}
          </div>
          <Report
            key="agent_tournament_report_regular"
            className="mt-3"
            reportId="agent_tournament_ranking"
            view="table"
            limit="10"
            filterId="agent_tournament_ranking"
          ></Report>
        </div>
      </div>
    </LayoutSection>
  );
}
export default withTranslation()(AgentTournamentDetails);
